var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.014,
    height: 51.338,
    viewBox: "0 0 56.014 51.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    transform: "translate(0.004 -0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M25.67,51.347A25.669,25.669,0,1,1,39.517,4.066a1.751,1.751,0,1,1-1.892,2.947A22.166,22.166,0,1,0,47.838,25.678c0-.731-.035-1.454-.1-2.166a1.75,1.75,0,0,1,3.484-.338q.119,1.236.119,2.5A25.7,25.7,0,0,1,25.67,51.347Zm0,0",
    fill: "#4f9b03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M161.59,50.517A1.737,1.737,0,0,1,160.354,50l-10.5-10.5a1.751,1.751,0,1,1,2.476-2.476l9.265,9.265,24.43-24.43a1.751,1.751,0,1,1,2.476,2.476L162.831,50a1.753,1.753,0,0,1-1.239.511Zm0,0",
    transform: "translate(-133.004 -19.005)",
    fill: "#4f9b03"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.67f14305885c1aa8fc85b49d803b7cd5.svg";
export { ForwardRef as ReactComponent };